import { useMutation } from 'react-query';

import { externalLogin as mutationFn } from 'api/endPoints/externalLogin';

export const useMutationExternalLogin = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    username: string;
    password: string;
    domain: string;
}

export interface QueryResponse {
    accessToken: string;
    email: string;
}
